var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPrintWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.321 11.371a2.222 2.222 0 0 0-1.628-.679h-.77V7.615c0-.32-.08-.673-.24-1.057-.16-.385-.353-.69-.577-.914L16.28 3.817c-.224-.224-.529-.416-.913-.577-.385-.16-.737-.24-1.058-.24H6.231c-.32 0-.593.112-.818.336a1.113 1.113 0 0 0-.336.818v6.538h-.77c-.632 0-1.175.227-1.628.68C2.226 11.823 2 12.366 2 13v5a.37.37 0 0 0 .114.27.37.37 0 0 0 .27.115h2.693v1.923c0 .32.112.593.336.817.225.224.497.337.818.337h11.538c.32 0 .594-.113.818-.337.224-.224.336-.497.336-.817v-1.923h2.693a.37.37 0 0 0 .27-.114A.37.37 0 0 0 22 18V13a2.22 2.22 0 0 0-.679-1.629zm-3.936 8.552H6.615v-3.077h10.77v3.077zm0-7.692H6.615V4.538h7.693v1.923c0 .321.112.593.336.818.225.224.497.336.818.336h1.923v4.616zm2.848 1.31a.74.74 0 0 1-.54.228.74.74 0 0 1-.541-.228.74.74 0 0 1-.228-.541.74.74 0 0 1 .228-.54.739.739 0 0 1 .54-.23.74.74 0 0 1 .541.23.74.74 0 0 1 .229.54.739.739 0 0 1-.229.54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrintWhite);
export default __webpack_public_path__ + "static/media/ic_print_white.f363ce02df7e5fded78cbd6185a1071e.svg";
export { ForwardRef as ReactComponent };